"use strict";

const { wrap_aff } = require('../../src/ForeignHelpers.js')

export const _init_tilt = id => options => wrap_aff((_, right) =>
	setTimeout(_ => right(VanillaTilt.init(document.getElementById(id), options)), 200))
